import { Outlet } from 'react-router'

/** Каркас без нижнего меню — вложенные экраны и многошаговые флоу (docs/domain.md §2). */
export function PlainLayout() {
  return <Outlet />
}
